<template>
  <div class="nav-footer">
    <div class="footer-container">
      <!-- 网站信息 -->
      <div class="footer-info">
        <div class="footer-logo" @click="$router.push('/')">
          <img src="@/assets/logo.jpg" alt="映雪笃学园" class="footer-logo-img" />
          <span>赣州市前沿科教设备有限公司</span>
        </div>
        <p class="description">专业的小学科教装备与数字资源平台，助力教师高效备课、学生快乐学习。</p>
        <div class="contact">
          <span><i class="el-icon-message"></i> 296539773@qq.com</span>
          <span><i class="el-icon-phone-outline"></i> 13479706005</span>
          <span><i class="el-icon-location-outline"></i> 江西省赣州市赣县区红金工业园4期河塘里路6号</span>
        </div>
      </div>

      <!-- 快速链接 -->
      <div class="footer-links">
        <h3>快速链接</h3>
        <ul>
          <li><a @click="goToPage('/')">首页</a></li>
          <li><a @click="goToPage('/resource')">资源中心</a></li>
          <li><a @click="goToPage('/products')">科教器材</a></li>
          <li><a @click="goToPage('/about')">公司简介</a></li>
          <li><a @click="goToPage('/news')">新闻动态</a></li>
          <!-- 意见反馈：未登录点击会被路由守卫带去登录页并自动回跳 -->
          <li><a @click="goToPage('/feedback')">意见反馈</a></li>
        </ul>
      </div>

      <!-- 教材版本 -->
      <div class="footer-versions">
        <h3>教材版本</h3>
        <ul>
          <li><a @click="goToPage('/resource?version=keda')">教科版 · 小学科学</a></li>
          <li><a @click="goToPage('/resource?version=sujiao')">苏教版 · 小学科学</a></li>
          <li><a @click="goToPage('/resource')">更多版本即将上线</a></li>
        </ul>
      </div>

      <!-- 关注我们 -->
      <div class="footer-social">
        <h3>关注我们</h3>
        <div class="social-icons">
          <i class="el-icon-weixin" title="微信公众号"></i>
          <i class="el-icon-weibo" title="微博"></i>
          <i class="el-icon-video-camera-solid" title="抖音"></i>
          <i class="el-icon-link" title="官网"></i>
        </div>
        <p>扫码关注公众号，获取最新教材资讯</p>
      </div>
    </div>

    <!-- 版权信息 -->
    <div class="footer-bottom">
      <p>© 2026 赣州前沿科教设备有限公司 版权所有 | 赣ICP备2026014971号 | 技术支持：黄文瑞（独立开发者）</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavFooter',
  methods: {
    goToPage(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
// 蓝色系变量
$primary-color: #409EFF;
$primary-light: rgba(64, 158, 255, 0.1);
$bg-dark: #2c3e50;
$bg-darker: #1a2533;
$text-light: #cfd9e6;
$text-muted: #8e99a9;

.nav-footer {
  background: linear-gradient(135deg, $bg-dark 0%, $bg-darker 100%);
  color: $text-light;
  padding-top: 46px;
  
  .footer-container {
    max-width: 1220px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding: 0 24px 30px;
    gap: 30px;
    flex-wrap: wrap;
  }
  
  .footer-info {
    flex: 2.2;
    min-width: 280px;
    
    .footer-logo {
      display: flex;
      align-items: center;
      margin-bottom: 18px;
      cursor: pointer;
      
      .footer-logo-img {
        height: 42px;
        margin-right: 12px;
      }
      
      span {
        font-size: 22px;
        font-weight: 700;
        color: #fff;
        letter-spacing: 1px;
      }
    }
    
    .description {
      color: $text-muted;
      margin-bottom: 20px;
      line-height: 1.7;
      font-size: 14px;
    }
    
    .contact {
      color: $text-muted;
      font-size: 13px;
      
      span {
        display: block;
        margin-bottom: 8px;
        
        i {
          margin-right: 8px;
          color: $primary-color;
          font-size: 14px;
        }
      }
    }
  }
  
  .footer-links,
  .footer-versions,
  .footer-social {
    flex: 1;
    min-width: 140px;
    
    h3 {
      font-size: 17px;
      margin-bottom: 18px;
      color: #fff;
      font-weight: 600;
      position: relative;
      
      &::after {
        content: '';
        display: block;
        width: 30px;
        height: 3px;
        background: $primary-color;
        margin-top: 8px;
        border-radius: 2px;
      }
    }
    
    ul {
      list-style: none;
      padding: 0;
      
      li {
        margin-bottom: 10px;
        
        a {
          color: $text-muted;
          cursor: pointer;
          transition: color 0.25s, padding-left 0.25s;
          text-decoration: none;
          display: inline-block;
          
          &:hover {
            color: $primary-color;
            padding-left: 5px;
          }
        }
      }
    }
  }
  
  .footer-social {
    .social-icons {
      display: flex;
      gap: 14px;
      margin-bottom: 18px;
      
      i {
        font-size: 26px;
        cursor: pointer;
        color: $text-muted;
        transition: color 0.25s, transform 0.25s;
        
        &:hover {
          color: $primary-color;
          transform: translateY(-3px);
        }
      }
    }
    
    p {
      color: $text-muted;
      font-size: 13px;
    }
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.07);
    text-align: center;
    padding: 18px 20px;
    
    p {
      color: $text-muted;
      font-size: 13px;
      margin: 0;
    }
  }
}

// 响应式
@media (max-width: 860px) {
  .nav-footer {
    .footer-container {
      flex-direction: column;
      gap: 32px;
    }
    
    .footer-info,
    .footer-links,
    .footer-versions,
    .footer-social {
      width: 100%;
      min-width: unset;
    }
  }
}

@media (max-width: 420px) {
  .nav-footer {
    .footer-logo span {
      font-size: 18px;
    }
    .contact span {
      font-size: 12px;
    }
  }
}
</style>